<div class="edit-status">
  @if (isOrderHistoryLoading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }
  <div class="edit-status__header">
    <h2 class="edit-status__title">
      {{ 'orders.editOrderStatus.title' | translate }}
    </h2>
    <button class="edit-status__close" type="button" (click)="onCancel()">
      <app-icon class="edit-status__cross-icon" [icon]="IconName.MODAL_CROSS" />
    </button>
  </div>

  <form class="edit-status__form" [formGroup]="editStatusForm" (ngSubmit)="onSave()">
    <div class="edit-status__form-fields">
      <div class="edit-status__form-field">
        <mat-label>
          {{ 'orders.editOrderStatus.form.currentStatus' | translate }}
        </mat-label>
        <span class="edit-status__current-status">{{ currentStatus() }}</span>
      </div>
      <div class="edit-status__form-field">
        <mat-label>
          {{ 'orders.editOrderStatus.form.newStatus' | translate }}
        </mat-label>
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="statusId"
            [placeholder]="'orders.editOrderStatus.form.newStatusPlaceholder' | translate"
          >
            @for (status of availableStatuses(); track status.id) {
              <mat-option [value]="status.name">
                {{ formatOrderStatus(status.name) }}
              </mat-option>
            }
          </mat-select>
          @if (editStatusForm.get('statusId')?.touched && editStatusForm.get('statusId')?.invalid) {
            <mat-error>
              {{ 'orders.editOrderStatus.form.errors.required' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="edit-status__form-field full-width">
        <mat-label>
          {{ 'orders.editOrderStatus.form.comment' | translate }}
        </mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <textarea
            matInput
            class="edit-status__comment"
            formControlName="comment"
            type="text"
            [placeholder]="'orders.editOrderStatus.form.commentPlaceholder' | translate"
          ></textarea>
          @if (
            editStatusForm.get('comment')?.touched &&
            editStatusForm.get('comment')?.hasError('required')
          ) {
            <mat-error>
              {{ 'orders.editOrderStatus.form.errors.required' | translate }}
            </mat-error>
          }
          @if (
            editStatusForm.get('comment')?.touched &&
            editStatusForm.get('comment')?.hasError('incorrectComment')
          ) {
            <mat-error>
              {{ 'orders.editOrderStatus.form.errors.incorrectComment' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (ordersHistory().length > 0) {
      <div class="edit-status__history">
        <table mat-table [dataSource]="ordersHistory()" class="full-width-table" matSort>
          @for (column of columnsConfig; track column.name) {
            <ng-container [matColumnDef]="column.name">
              <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
                {{ column.label | translate }}
              </th>

              <td [class]="column.cellClass" mat-cell *matCellDef="let item">
                @if (column.name === historyOrderKey.DATE) {
                  {{ item.creationDate | date: 'yyyy-MM-dd HH:mm:ss' }}
                } @else if (column.name === historyOrderKey.STATUS) {
                  <div class="status-container">
                    <span class="status" [ngClass]="item.orderStatus.toLowerCase()">
                      {{ formatOrderStatus(item.orderStatus) }}
                    </span>
                  </div>
                } @else if (column.name === historyOrderKey.COMMENT) {
                  {{ item.comment || '-' }}
                } @else {
                  {{ item[column.name] || '-' }}
                }
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }

    <div class="edit-status__btnWrapper">
      <button type="button" class="edit-status__button btn-white" (click)="onCancel()">
        {{ 'orders.editOrderStatus.buttons.cancel' | translate }}
      </button>

      <button type="submit" class="edit-status__button btn-primary">
        {{ 'orders.editOrderStatus.buttons.save' | translate }}
      </button>
    </div>
  </form>
</div>
